import React from "react";
import { StyleSheet, TouchableOpacity } from "react-native";
import Text from "@components/AppText";
import t from "@constants/localization";

const PATH = "screens/CLProfile/components/saveButton";

export default function SaveButton(props) {
  const { handlePress = () => {}, isActive, index } = props;

  const handleClick = () => {
    handlePress(index);
  };

  return (
    <TouchableOpacity
      onPress={isActive ? handleClick : null}
      style={[
        {
          backgroundColor: isActive ? "#E40046" : "rgba(0, 0, 0, 0.1)",
        },
        styles.button,
      ]}
    >
      <Text style={styles.btnText}>{t(`${PATH}/save`)}</Text>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  button: {
    alignSelf: "flex-end",
    marginLeft: 10,
    marginBottom: 10,
    borderWidth: 1,
    borderRadius: 10,
    borderColor: "rgba(0, 0, 0, 0.1)",
    padding: 12,
    paddingHorizontal: 50,
    width: "95%",
    alignItems: "center",
  },
  btnText: {
    color: "white",
    fontFamily: "NotoSansDevanagari-Bold",
    position: "relative",
    top: 2,
  },
});
